import React, { useEffect } from "react";
import "./Popup.scss";

interface PopupProps {
  show: boolean; // Controls the visibility of the popup
  headerText: string; // Text to display in the header
  onClose: () => void; // Callback for close button click
  children?: React.ReactNode; // Content of the popup
  /** How wide the dialog may grow: 520 / 760 / 980px. A single-column form
   *  wants sm; a multi-column one needs the room. */
  size?: "sm" | "md" | "lg";
  /** Goes on the dialog itself, for one-off layout tweaks. */
  className?: string;
  /** Off by default: a stray click beside a half-filled form should not
   *  discard it. Worth enabling for short confirmations. */
  closeOnOverlayClick?: boolean;
  /** Goes on the container div, for one-off layout tweaks. */
  placement?: 'top' | 'center' | 'bottom'| 'left' | 'right' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

const Popup: React.FC<PopupProps> = ({
  show,
  headerText,
  onClose,
  children,
  size = "sm",
  className = "",
  placement = "center",
  closeOnOverlayClick = false,
}) => {
  // Otherwise the page behind carries on scrolling under the dialog.
  useEffect(() => {
    if (!show) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className={`popup-overlay ${placement}`.trim()}
      onClick={(event) => {
        if (closeOnOverlayClick && event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className={`popup-container popup-${size} ${className}`.trim()}>
        <div className="popup-header">
          <h3 className="popup-title">{headerText}</h3>
          <button className="popup-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="popup-content">{children}</div>
      </div>
    </div>
  );
};

export default Popup;
